import React, { Component } from 'react';
import PropTypes from 'prop-types'
import classnames from 'classnames';
import Style from './Tab.less';

const CLASS_ROOT = "tab";

export default class Tab extends Component {

  constructor() {
    super();
    this._onClickTab = this._onClickTab.bind(this);
  }

  _onClickTab(event) {
    //console.log("u just clicked... passing to parent");
    const { onRequestForActive } = this.props;
    if (event) {
      event.preventDefault();
    }
    onRequestForActive();
  }

  render() {
    const { active, className, id, title, ...props } = this.props;
    //console.log(active);
    delete props.onRequestForActive;
    /*
    const classes = classnames(
      CLASS_ROOT, {
        [`${CLASS_ROOT}--active`]: active
      },
      className
    );*/
    let styleTabLabel, styleTabButton, styleTab;
    if (active) {
      styleTabLabel = { display: 'inline-block', cursor: 'pointer', paddingBottom: '10px', color: '#666', borderBottom: '4px solid rgb(97,71,103)' }
      styleTabButton = { backgroundColor: 'white', borderStyle: 'none', paddingRight: '30px' };
      styleTab = { padding: '0 20px', }
    } else {
      styleTabLabel = { display: 'inline-block', cursor: 'pointer', paddingBottom: '10px', color: '#666', borderBottom: '4px solid transparent' }
      styleTabButton = { backgroundColor: 'white', borderStyle: 'none', paddingRight: '30px' };
      styleTab = { padding: '0 20px', }
    }


    //Active
    //const 
    return (
      <li {...props} style={styleTab} id={id}>
        <span style={styleTabButton} 
          role='tab' aria-selected={active}
          onClick={this._onClickTab} aria-expanded={active}>
          <label style={styleTabLabel} htmlFor={id}>
            {title}
          </label>
        </span>
      </li>
    );
  }
}

Tab.propTypes = {
  title: PropTypes.node,
  active: PropTypes.bool,
  id: PropTypes.string,
  onRequestForActive: PropTypes.func // from Tabs
};



// WEBPACK FOOTER //
// ./src/tabs/Tab.js